// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Vuex from 'vuex';
import store from './store'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from './http/config'
Vue.use(Vuex);
//挂载swiper
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper);
Vue.prototype.$http = axios;

Vue.config.productionTip = false;
Vue.use(ElementUI);

Vue.mixin({
  data() {
    return {
      navList:[{
        name:'首页',
        toLink:'/main/index'
      },{
        name:'霏凡集团',
        toLink:'/main/group',
        navChildList:[{
          name:'集团介绍',
          toLink:'/introduction'
        },{
          name:'董事长致辞',
          toLink:'/speech'
        },{
          name:'企业文化',
          toLink:'/culture'
        },{
          name:'团队介绍',
          toLink:'/team'
        },{
          name:'企业荣誉',
          toLink:'/contexts'
        }]
      },{
        name:'新闻公告',
        toLink:'/main/newsNotice'
      },{
        name:'主营业务',
        toLink:'/main/business',
        navChildList:[{
          name:'房地产开发',
          toLink:'/realty'
        },{
          name:'旗下子公司',
          toLink:'/subsidiary'
        }]
      },{
        name:'发展历史',
        toLink:'/main/development',
        navChildList:[{
          name:'成长历程',
          toLink:'/course'
        },{
          name:'大事记',
          toLink:'/bigEvents'
        }]
      },{
        name:'招聘人才',
        toLink:'/main/recruit',
        navChildList:[{
          name:'人才理念',
          toLink:'/personnelIdea'
        },{
          name:'人才招聘',
          toLink:'/personnelRecruit'
        }]
      },{
        name:'联系我们',
        toLink:'/main/contact',
        navChildList:[{
          name:'联系总部',
          toLink:'/headquarters'
        },{
          name:'廉洁举报',
          toLink:'/report'
        }]
      }]
    }
  }
})

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js